export class HyperLink {
    constructor(text, url, title, target) {
        this.text = text;
        this.title = title;
        this.target = target;
        this.url = url;
    }
    render() {
        let a = document.createElement('a');
        a.textContent = this.text;
        if (this.title) {
            a.setAttribute('title', this.title);
        }
        if (this.target) {
            a.setAttribute('target', this.target);
        }
        a.href = this.url;
        return a;
    }
}
